import styled from "styled-components";

import PhoneCarousel from "./PhoneCarousel";

import { MydLogoHighlight } from "src/assets/svgs";
import { MYD_CAPTURES } from "src/assets/images/captures";

function Preview() {
  return (
    <S.Container>
      <S.ScreenContainer>
        <PhoneCarousel captures={MYD_CAPTURES} />

        <span>마이디 서비스 미리보기</span>
      </S.ScreenContainer>
      <S.TextContainer>
        <S.SubText>나의 데이터, 직접 거래하자!</S.SubText>

        <S.MainTextTop>
          일상에서 <MydLogoHighlight />를 모으다
        </S.MainTextTop>
        <S.MainText>이제는 마이디 하세요!</S.MainText>
      </S.TextContainer>
    </S.Container>
  );
}

export default Preview;

const S = {
  Container: styled.section`
    width: 100%;
    height: 1039px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `,
  ScreenContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 341px;
    span {
      text-align: center;
      font-size: 20px;
      letter-spacing: -0.46px;
      margin-top: 20px;
    }
  `,
  TextContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 135px;
  `,
  SubText: styled.p`
    font-size: 40px;
    letter-spacing: -0.92px;
    white-space: nowrap;
  `,
  MainText: styled.p`
    font-size: 60px;
    font-weight: 700;
    line-height: 80px;
    letter-spacing: -1.38px;
    white-space: nowrap;
  `,
  MainTextTop: styled.p`
    font-size: 60px;
    font-weight: 700;
    line-height: 80px;
    letter-spacing: -1.38px;
    display: flex;
    align-items: center;
    margin-top: 22px;
    white-space: nowrap;
    svg {
      margin: 0 4px 0 16px;
      align-self: flex-end;
    }
  `,
};
